export default "__VITE_ASSET__eBMKeWnU__"